import * as React from 'react'
import { FieldInputProps } from 'formik'
import { useTranslation } from 'react-i18next'

import './textInput.sass'

interface Props {
    id: string
    label?: string
    placeholder?: string
    field?: FieldInputProps<string>
    type: 'text' | 'email' | 'password' | 'number'
    autocomplete?: string
}

const TextInput: React.FunctionComponent<Props> = ({ label, placeholder, field, type, autocomplete }: Props) => {
    const [t] = useTranslation()
    return (
        <div className="textInput">
            {field && (
                <>
                    {label && <label htmlFor={field.name}>{t(label)}</label>}
                    <input
                        type={type}
                        id={field.name}
                        placeholder={t(placeholder)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') e.preventDefault()
                        }}
                        {...field}
                        autoComplete={autocomplete}
                    />
                </>
            )}
        </div>
    )
}

export default TextInput
